<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button (click)="cancelContract()">
                <ion-icon slot="icon-only" name="arrow-back"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-title>{{title}}</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content #content>
    <ion-card>
        <ion-card-header>
            <ion-card-subtitle>Load Existing Contract</ion-card-subtitle>
          </ion-card-header>
        <ion-item>
         
          <ion-label>Contract No :</ion-label>
          <ion-input name="contractNumber" type="number" [(ngModel)]="contractNumber"></ion-input>
          <ion-button fill="solid" size="default" slot="end" (click)="handleLoadContract()">Load</ion-button>
        </ion-item>
      </ion-card>
    
    <datepicker *ngIf="documentTemp.customer.name" [document]="documentTemp"></datepicker>
    <!--location-select [document]="documentTemp"></location-select-->
    <customer  *ngIf="documentTemp.customer.name" [document]="documentTemp" [readonly]="true" (customerChange)="listenCustomer($event)"
              (documentChange)="listenDocument($event)"></customer>
    <order-number *ngIf="documentTemp.customer && documentTemp.customer.$loki" [document]="documentTemp"></order-number>
    <site *ngIf="documentTemp.site.name" [document]="documentTemp"></site>
    <contactdetails *ngIf="documentTemp.contact.name" [document]="documentTemp"></contactdetails>
    <!--items-order-fulfilment *ngIf="documentTemp.documentType === 1 && documentTemp.parentDocument"
                            [document]="documentTemp"></items-order-fulfilment-->
    <items *ngIf="documentTemp.customer.name" [document]="documentTemp" [readonly] = "true"></items>
    <!--    <payment *ngIf="documentTemp.detailLines.length > 0" [document]="documentTemp"></payment>-->
    <picturestaken *ngIf="documentTemp.customer.name" [document]="documentTemp"></picturestaken>
    <!--sign-now-or-later [document]="documentTemp"></sign-now-or-later-->
    <!--app-signature *ngIf="!documentTemp.signLater" [document]="documentTemp"
                   (signatureChange)="listenSignature($event)"></app-signature>
    <select-queue-operator *ngIf="documentTemp.signLater" [document]="documentTemp"></select-queue-operator>
    <comments [document]="documentTemp"></comments-->

    <ion-fab vertical="bottom" horizontal="end" slot="fixed">
        <ion-fab-button (click)="saveContract()" color="success">
            <ion-icon name="checkmark"></ion-icon>
        </ion-fab-button>
    </ion-fab>

</ion-content>


